import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var MicOff = createReactComponent("MicOff", ["svg", defaultAttributes, [["line", {
  x1: "1",
  y1: "1",
  x2: "23",
  y2: "23",
  key: "czowfk"
}], ["path", {
  d: "M9 9v3a3 3 0 005.12 2.12M15 9.34V4a3 3 0 00-5.94-.6",
  key: "1pfz6f"
}], ["path", {
  d: "M17 16.95A7 7 0 015 12v-2m14 0v2a7 7 0 01-.11 1.23",
  key: "ul691t"
}], ["line", {
  x1: "12",
  y1: "19",
  x2: "12",
  y2: "23",
  key: "2d2mwp"
}], ["line", {
  x1: "8",
  y1: "23",
  x2: "16",
  y2: "23",
  key: "52tlcf"
}]]]);
export default MicOff;